import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'

Vue.use(Vuex);
import store from '../store/store'

//首页
const ScanRegister = () => import(/*webpackChunkName:'index',*/'@/views/ScanRegister')
const Register = () => import(/*webpackChunkName:'index',*/'@/views/Register')
const SecondaryRegister = () => import(/*webpackChunkName:'index',*/'@/views/SecondaryRegister')
const ApplyDetail = () => import(/*webpackChunkName:'index',*/'@/views/ApplyDetail')
const PeopleControl = () => import(/*webpackChunkName:'index',*/'@/views/PeopleControl')
const ChoosePerson = () => import(/*webpackChunkName:'index',*/'@/views/ChoosePerson')
const PeopleControlTel = () => import(/*webpackChunkName:'index',*/'@/views/PeopleControlTel')
const HistoryPeople = () => import(/*webpackChunkName:'index',*/'@/views/HistoryPeople')
const AddPeople = () => import(/*webpackChunkName:'index',*/'@/views/AddPeople')
const ReturnTrip = () => import(/*webpackChunkName:'index',*/'@/views/ReturnTrip')
const VisitRouter = () => import(/*webpackChunkName:'index',*/'@/views/VisitRouter')
const Qrym = () => import(/*webpackChunkName:'index',*/'@/views/Qrym')
const Cglx = () => import(/*webpackChunkName:'index',*/'@/views/ChooseTourRoute')

const Cglx2 = () => import(/*webpackChunkName:'index',*/'@/views/ChooseTourRoute2')
const Login = () => import(/*webpackChunkName:'index',*/'@/views/login')
const Tybd = () => import(/*webpackChunkName:'index',*/'@/views/Tybd')
const Apply = () => import(/*webpackChunkName:'index',*/'@/views/Apply')
const SeatInquiry = () => import('@/views/SeatInquiry')
//浏览器打开的页面
const HyHome = () => import(/*webpackChunkName:'index',*/'@/views/Explorer/HyHome')
const ByPhoneSearch = () => import(/*webpackChunkName:'index',*/'@/views/Explorer/ByPhoneSearch')
const PeopleControl2 = () => import(/*webpackChunkName:'index',*/'@/views/Explorer/PeopleControl2')
const ApplyDetail2 = () => import(/*webpackChunkName:'index',*/'@/views/Explorer/ApplyDetail2')
const ChoosePerson2 = () => import(/*webpackChunkName:'index',*/'@/views/Explorer/ChoosePerson2')
const SecondaryRegister2 = () => import(/*webpackChunkName:'index',*/'@/views/Explorer/SecondaryRegister2')
const ReturnJourney = () => import(/*webpackChunkName:'index',*/'@/views/Explorer/ReturnJourney')


Vue.use(Router)
const staticRouters = [
  {
    path: '/',
    redirect: {name: 'scanRegister'},
  },
  {
    path: '/scanRegister',
    name: 'scanRegister',
    component: ScanRegister,
    meta: {
      title: '报名系统'
    },
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: '注册页面'
    },
  },
  {
    path: '/secondaryRegister',
    name: 'secondaryRegister',
    component: SecondaryRegister,
    meta: {
      title: '填写住宿信息'
    },
  },
  {
    path: '/applyDetail',
    name: 'applyDetail',
    component: ApplyDetail,
    meta: {
      title: '人员详情页'
    },
  },
  {
    path: '/peopleControl',
    name: 'peopleControl',
    component: PeopleControl,
    meta: {
      title: '人员列表'
    },
  },
  {
    path: '/choosePerson',
    name: 'choosePerson',
    component: ChoosePerson,
    meta: {
      title: '选择人员'
    },
  },
  {
    path: '/peopleControlTel',
    name: 'peopleControlTel',
    component: PeopleControlTel,
    meta: {
      title: '验证同行人员手机号'
    },
  },
  {
    path: '/historyPeople',
    name: 'historyPeople',
    component: HistoryPeople,
    meta: {
      title: '历史同行人员'
    },
  },
  {
    path: '/addPeople',
    name: 'addPeople',
    component: AddPeople,
    meta: {
      title: '编辑人员信息'
    },
  },
  {
    path: '/return',
    name: 'returnTrip',
    component: ReturnTrip,
    meta: {
      title: '回程页面'
    },
  },
  {
    path: '/vrouter',
    name: 'visitRouter',
    component: VisitRouter,
    meta: {
      title: '访问路线'
    },
  },
  {
    path: '/qrym',
    name: 'qrym',
    component: Qrym,
    meta: {
      title: '签到页面'
    },
  },
  {
    path: '/cglx',
    name: 'cglx',
    component: Cglx,
    meta: {
      title: '调研路线页面'
    },
  },
  {
    path: '/cglx2',
    name: 'cglx2',
    component: Cglx2,
    meta: {
      title: '专题工作坊页面'
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录页面'
    },
  },
  {
    path: '/tybd',
    name: 'tybd',
    component: Tybd,
    meta: {
      title: '统一报到'
    },
  },
  {
    path: '/apply',
    name: 'apply',
    component: Apply,
    meta: {
      title: '立即报名'
    },
  },
  {
    path: '/home',
    name: 'home',
    component: HyHome,
    meta: {
      title: '签到页面'
    },
  },
  {
    path: '/byPhoneSearch',
    name: 'byPhoneSearch',
    component: ByPhoneSearch,
    meta: {
      title: '验证手机号'
    },
  },
  {
    path: '/peopleControl2',
    name: 'peopleControl2',
    component: PeopleControl2,
    meta: {
      title: '人员列表'
    },
  },
  {
    path: '/applyDetail2',
    name: 'applyDetail2',
    component: ApplyDetail2,
    meta: {
      title: '人员详情页'
    },
  },
  {
    path: '/choosePerson2',
    name: 'choosePerson2',
    component: ChoosePerson2,
    meta: {
      title: '选择人员'
    },
  },
  {
    path: '/secondaryRegister2',
    name: 'secondaryRegister2',
    component: SecondaryRegister2,
    meta: {
      title: '填写住宿信息'
    },
  },
  {
    path: '/returnJourney',
    name: 'returnJourney',
    component: ReturnJourney,
    meta: {
      title: '回程信息'
    }
  },
  {
    path: '/seatInquiry',
    name: 'seatInquiry',
    component: SeatInquiry,
    meta: {
      title: '"人工智能+数字校园"学术活动'
    }
  },
];

const router = new Router({
  mode: 'history',
  routes: staticRouters,
  //滚动行为
  scrollBehavior(to, form, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})
// 动态添加路由,登录后开放‘新生办理业务’
// const dynamicRouters = [{
//     path: '/stuywbl',
//     name: 'stuywbl',
//     component: StuYwbl
// }]
// router.addRoutes(dynamicRouters);

// 路由守卫
router.beforeEach((to, from, next) => {
  //通过路由设置浏览器标题
  if (typeof to.meta.title !== 'undefined') {
    document.title = to.meta.title
  }
  store.commit('updateLoadingStatus', {isLoading: true})
  if (to.path.indexOf('tybd') > -1 && to.path != location.pathname) {
    //调用微信功能的需要刷新页面
    location.assign(to.fullPath);
  } else {
    next();
  }
})
router.afterEach((to) => {
  store.commit('updateLoadingStatus', {isLoading: false})
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js